module.exports = __webpack_public_path__ + "static/media/menu-en-2.e05600e8.svg";